import { render, staticRenderFns } from "./little-volunteer-appoint.vue?vue&type=template&id=079f3c24&scoped=true"
import script from "./little-volunteer-appoint.vue?vue&type=script&lang=js"
export * from "./little-volunteer-appoint.vue?vue&type=script&lang=js"
import style0 from "./little-volunteer-appoint.vue?vue&type=style&index=0&id=079f3c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f3c24",
  null
  
)

export default component.exports